<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { getAction,postAction } from '@/api/manage'
export default {
    props: {
        titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('水质传感器工作情况'),
            option: {},
            url:{
                //OnLineStatistical:"/wq/wQDataRecord/queryOnLineStatistical"
                OnLineStatistical:"/jeecg-charge/wq/meterDeviceBase/queryOnLineStatistical"
            },
            OnLineStatistical:[],
            intervalId: null,
            angle: 0
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.resetData()
            this.queryOnLineStatistical();
        },
        resetData() {
            this.option = this.$options.data.call(this).option
            if(this.intervalId !== null){
                clearInterval(this.intervalId)
                this.intervalId = null;
            }
            this.angle = this.$options.data.call(this).angle
        },
        queryOnLineStatistical() {
            let params = {deviceType: 'WaterQuality'}
            
            getAction(this.url.OnLineStatistical, params).then((res) => {
            if(res.success){
                this.OnLineStatistical = res.result;
                // console.log(this.OnLineStatistical);
                this.setOption()
                setTimeout(()=> {
                    this.intervalId = setInterval(()=>{
                        this.angle = this.angle + 5
                        this.setOption()
                    },100)
                },1000)
            }
            }) 
        },
        setOption() {
            let angle = this.angle
            let data = [
                {value: this.OnLineStatistical.onlineCount, name: this.$t('在线')},
                {value: this.OnLineStatistical.offlineCount, name: this.$t('离线')},
            ]
            // console.log(data);
            let total = this.OnLineStatistical.totalCount;
            // console.log(this.OnLineStatistical);
            let color = [{start: '#00D2FF',end: '#3A7BD5'},{start: '#FAD961',end: '#F76B1C'},{start: '#60E0B2',end: '#1DCC8C'}]
            let seriesData = []
            let innerSeriesData = []
            for(let i = 0;i < data.length;i++) {
                innerSeriesData.push({
                    value: 12,
                    name: '',
                    itemStyle: {
                        normal: {
                            borderWidth: 5
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
                    }
                })
                // console.log(innerSeriesData);
                // console.log(data[i])
                seriesData.push({
                    name: data[i].name,
                    value: data[i].value,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                [
                                    {offset: 0, color: color[i].start},
                                    {offset: 1, color: color[i].end}
                                ]
                            ),
                            borderColor:new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                [
                                    {offset: 0, color: color[i].start},
                                    {offset: 1, color: color[i].end}
                                ]
                            ),
                            
                        }
                    }
                })
            }
            this.option = {
                color: ['#F76B1C','#0067FF', '#1DCC8C'],
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                title: {
                    text: `{total|${total}}{unit|${this.$t('个')}}`,
                    textStyle: {
                        color: '#52C4DF',
                        rich: {
                            total: {
                                color: '#52C4DF',
                                fontWeight: 500,
                                fontSize: 24,
                                fontFamily: 'ds-digital-bold'

                            },
                            unit: {
                                color: '#2A6BAC',
                                fontSize: 12,
                            }
                        }
                    },
                    left: 'center',
                    top: 'center',
                    itemGap: 0,
                    subtext: this.$t('总计'),
                    subtextStyle: {
                        color: '#fff',
                        verticalAlign: 'middle',
                        lineHeight: 12
                    }
                },
                series: [
                    {
                    name: "ring5",
                    type: 'custom',
                    coordinateSystem: "none",
                    renderItem: function(params, api) {
                        return {
                            type: 'arc',
                            shape: {
                                cx: api.getWidth() / 2,
                                cy: api.getHeight() / 2,
                                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                startAngle: (0 + angle) * Math.PI / 180,
                                endAngle: (90 + angle) * Math.PI / 180
                            },
                            style: {
                                stroke: "#00A2F3",
                                opacity: 0.5,
                                fill: "transparent",
                                lineWidth: 2
                            },
                            silent: true
                        };
                    },
                    data: [0]
                },
                {
                    name: "ring5",
                    type: 'custom',
                    coordinateSystem: "none",
                    renderItem: function(params, api) {
                        return {
                            type: 'arc',
                            shape: {
                                cx: api.getWidth() / 2,
                                cy: api.getHeight() / 2,
                                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                startAngle: (120 + angle) * Math.PI / 180,
                                endAngle: (210 + angle) * Math.PI / 180
                            },
                            style: {
                                stroke: "#00A2F3",
                                opacity: 0.5,
                                fill: "transparent",
                                lineWidth: 2
                            },
                            silent: true
                        };
                    },
                    data: [0]
                },
                {
                    name: "ring5",
                    type: 'custom',
                    coordinateSystem: "none",
                    renderItem: function(params, api) {
                        return {
                            type: 'arc',
                            shape: {
                                cx: api.getWidth() / 2,
                                cy: api.getHeight() / 2,
                                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                startAngle: (240 + angle) * Math.PI / 180,
                                endAngle: (330 + angle) * Math.PI / 180
                            },
                            style: {
                                stroke: "#00A2F3",
                                fill: "transparent",
                                opacity: 0.5,
                                lineWidth: 2
                            },
                            silent: true
                        };
                    },
                    data: [0]
                },
                    {
                        name: '',
                        type: 'pie',
                        radius: ['50%', '55%'],
                        center: ['50%', '50%'],
                        animationDelay: 100,
                        animationDuration: 2000,
                        label: {
                            show: true,
                            position: 'outer',
                            width:0,
                            height: 0,
                            lineHeight: 0,
                            padding: [2,-2,2,-2],
                            borderRadius: 2,
                            distanceToLabelLine: 0,
                            formatter: (params) => {
                                if(total == 0) {
                                    let percent = 100
                                }
                                let index = params.dataIndex
                                let percent = ((params.value / total) * 100).toFixed(0);
                                return [`{topnumber${index}|${params.value}}{top${index}|${this.$t('个')}}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,`{hr${index}|}`].join('\n')
                            },
                            align: 'center',
                            rich: this.setRichText(color)
                        },
                        labelLine: {
							normal: {
								smooth: 0.2,
								length: 15,
								length2: 45,
							}
						},
                        data: seriesData
                    }
                ]
            };
        },
        setRichText(colorList) {
            let richList = {}
            for(let i = 0;i< colorList.length;i++) {
                richList[`top${i}`] = {
                    color: colorList[i].start,
                    verticalAlign: 'bottom',
                    padding: [5, 0, 0, 0],
                    align: 'center'
                }
                richList[`topnumber${i}`] = {
                    color: colorList[i].start,
                    fontFamily: 'ds-digital-bold',
                    verticalAlign: 'bottom',
                    padding: [5, 0, 0, 0],
                    fontSize: 20,
                    align: 'center'
                }
                richList[`bottom${i}`] = {
                    color: colorList[i].start,
                    verticalAlign: 'top',
                    padding: [0, 0, 5, 0],
                    align: 'center'
                }
                richList[`hr${i}`] = {
                    backgroundColor: colorList[i].start,
                    borderRadius: 3,
                    width: 3,
                    height: 3,
                    align: 'center',
                    padding: [3, 3, 0, -12]
                }
            }
            return richList
        }
    },
    beforeDestroy() {
        this.angle = 0;
        if(this.intervalId !== null){
            clearInterval(this.intervalId)
            this.intervalId = null;
        }
    }
}
</script>